'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RpcSystem = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _ServiceDescriptor = require('./ServiceDescriptor');

var _QueryCache = require('./QueryCache');

var _Void = require('./Void');

var _nestedUtils = require('../nestedUtils');

var _nestedtypes = require('nestedtypes');

var Nested = _interopRequireWildcard(_nestedtypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var logger = _auroraJavascriptUtils.log.getLogger('rpc');

var DEFAULT_QUERY_CACHE_TTL = 60 * 1000;
var DEFAULT_QUERY_CACHE_KEY_EXTRACTOR = function DEFAULT_QUERY_CACHE_KEY_EXTRACTOR(request) {
    return JSON.stringify(request); // todo(LUNA-2252): add test & add sorting
};

var COLLECTION_SUFFIX = '[]';

var RpcSystem = exports.RpcSystem = function () {
    function RpcSystem(domain) {
        _classCallCheck(this, RpcSystem);

        this.domain = _auroraJavascriptUtils.assert.object(domain);
        this.serviceDescriptors = {};
        this.queryCache = new _QueryCache.QueryCache();
    }

    _createClass(RpcSystem, [{
        key: 'registerService',
        value: function registerService(serviceName, serviceFactory) {
            var _this = this;

            _auroraJavascriptUtils.assert.string(serviceName);
            _auroraJavascriptUtils.assert.func(serviceFactory);

            if (this.serviceDescriptors[serviceName]) {
                throw new Error('service with name \'' + serviceName + '\' already registered');
            }

            var getModel = function getModel(modelName) {
                if ((0, _nestedUtils.isModelClass)(modelName)) {
                    return modelName;
                }

                if (modelName === 'void') {
                    return _Void.Void;
                }

                // support for collections
                if (modelName.endsWith(COLLECTION_SUFFIX)) {
                    var collectionElementModelName = modelName.substr(0, modelName.length - COLLECTION_SUFFIX.length);
                    var Model = _this.domain.getModel(collectionElementModelName);
                    return Model.Collection;
                }

                return _this.domain.getModel(modelName);
            };

            var serviceDescriptor = this.serviceDescriptors[serviceName] = new _ServiceDescriptor.ServiceDescriptor(serviceName, getModel);

            var options = {
                superAgent: this.domain.superAgent,
                urlBuilder: this.domain.createUrlBuilder
            };

            var enhancementsOptions = {
                Command: function Command(meta) {
                    return serviceDescriptor.createCommandDecorator(meta);
                },
                Query: function Query(meta) {
                    return serviceDescriptor.createQueryDecorator(meta);
                },
                Cacheable: function Cacheable(_ref) {
                    var _ref$ttl = _ref.ttl,
                        ttl = _ref$ttl === undefined ? DEFAULT_QUERY_CACHE_TTL : _ref$ttl,
                        _ref$keyExtractor = _ref.keyExtractor,
                        keyExtractor = _ref$keyExtractor === undefined ? DEFAULT_QUERY_CACHE_KEY_EXTRACTOR : _ref$keyExtractor;

                    _auroraJavascriptUtils.assert.number(ttl);
                    _auroraJavascriptUtils.assert.func(keyExtractor);

                    return function (target, key, descriptor) {
                        return descriptor;
                    };
                },

                CacheEvict: function CacheEvict() {
                    return function (target, key, descriptor) {
                        return descriptor;
                    };
                },
                EvictCollectionCache: function EvictCollectionCache(modelNames) {
                    _auroraJavascriptUtils.assert.array(modelNames);

                    var domain = _this.domain;

                    var _$partition = _underscore2.default.partition(modelNames, function (name) {
                        return !/\./.test(name);
                    }),
                        _$partition2 = _slicedToArray(_$partition, 2),
                        myModelNames = _$partition2[0],
                        neighbourModelNames = _$partition2[1];

                    var myModels = myModelNames.map(function (modelName) {
                        return domain.getModel(modelName);
                    });

                    return function (target, key, descriptor) {
                        var originalMethod = descriptor.value;

                        descriptor.value = function overriddenMethod() {
                            return originalMethod.apply(this, arguments).then(function (result) {
                                try {
                                    myModels.forEach(function (model) {
                                        return domain.getCache().invalidate(model);
                                    });

                                    if (typeof domain.emit !== 'function') {
                                        logger.error('domain can not emit events');
                                        return result;
                                    }

                                    neighbourModelNames.forEach(function (modelName) {
                                        return domain.emit('evictCache', modelName);
                                    });
                                } catch (e) {
                                    logger.warn('can\'t invalidate models ' + modelNames);
                                }

                                return result;
                            });
                        };
                    };
                },
                /**
                 * Call list of queries after successful completion of command.
                 * To avoid infinite cycles dont use it with @Query
                 */
                CallQueries: function CallQueries(queryNames) {
                    _auroraJavascriptUtils.assert.array(queryNames);

                    var domain = _this.domain;


                    return function (target, key, descriptor) {
                        var originalMethod = descriptor.value;

                        descriptor.value = function overriddenMethod() {
                            return originalMethod.apply(this, arguments).then(function (result) {
                                if (typeof domain.emit !== 'function') {
                                    logger.error('domain can not emit events');
                                    return result;
                                }
                                queryNames.forEach(function (method) {
                                    return domain.emit('callQuery', method);
                                }); // method = 'domain.service.method'
                                return result;
                            });
                        };
                    };
                },
                Href: function Href(meta) {
                    return function (target, key, descriptor) {
                        var originalMethod = descriptor.value;

                        var queryParamsConstructor = getModel(meta.queryParams);

                        var HrefClass = Nested.Model.extend({
                            defaults: {
                                queryParams: queryParamsConstructor
                            },
                            getUrl: function getUrl(additionalParams) {
                                return originalMethod(this.queryParams, additionalParams);
                            }
                        });

                        descriptor.value = function (rawParams) {
                            return new HrefClass({ queryParams: rawParams });
                        };

                        return descriptor;
                    };
                }
            };

            var service = serviceFactory(options, enhancementsOptions);
            this.domain.services[serviceName] = service;
            return service;
        }
    }, {
        key: 'getServiceDescriptor',
        value: function getServiceDescriptor(serviceName) {
            if (!this.serviceDescriptors[serviceName]) {
                throw new Error('can\'t find service with name \'' + serviceName + '\'');
            }

            return this.serviceDescriptors[serviceName];
        }
    }]);

    return RpcSystem;
}();


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/rpc/RpcSystem.js
// module id = 1422
// module chunks = 118